import mapSliceToComponent from '~/imports/account_page'

import { AccountDashboard } from '~/components/Account'
import SliceManager from '~/components/UI/SliceManager'

import { ClientPageView } from '~/providers/GTMTrackingProvider/ClientPageView'

import withAuthentication from '~/hocs/withAuthentication'

import { getAccountPageStaticProps } from '~/data/account-page-data'
import { AccountPageData } from '~/data/account-page-data/serializer'

function Account({ slices, ...props }: AccountPageData) {
  return (
    <>
      <AccountDashboard {...props} />
      <SliceManager
        mapSliceTypeToComponent={mapSliceToComponent}
        slicesData={slices}
        customStartPosition={2}
      />
      <ClientPageView template="customers/account" />
    </>
  )
}

export default withAuthentication(Account)

export const getStaticProps = getAccountPageStaticProps()
